module.exports = __webpack_public_path__ + "static/media/confetti.ead75fe7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/confetti.svg
// module id = 498
// module chunks = 0